// src/pages/AddListing/uploadUtils.js
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../../services/firebase";

// Helper: upload images for a listing and return their download URLs
export const uploadListingImages = async (listingId, images) => {
  const urls = [];
  for (const file of images) {
    // Basic validations (optional)
    if (!file.type.startsWith("image/")) {
      throw new Error(`File "${file.name}" is not an image.`);
    }
    const MAX_MB = 2;
    if (file.size > MAX_MB * 1024 * 1024) {
      throw new Error(`"${file.name}" exceeds ${MAX_MB}MB.`);
    }
    const fileRef = ref(
      storage,
      `images/listings/${listingId}/${Date.now()}-${file.name}`
    );
    await uploadBytes(fileRef, file);
    const url = await getDownloadURL(fileRef);
    urls.push(url);
  }
  return urls;
};